import type { StoryboardShot } from '../../services/studioService';

/** What a panel's verdict says, in plain words, when it may not show the right person (QUALITY-2). */
export function qualityMiss(shot: StoryboardShot): { label: string; detail: string } | null {
  const q = shot.previewQuality;
  if (!q || q.passes) return null;
  const who = q.cast || 'the cast member';
  const parts = [q.misses.length ? `Missing: ${q.misses.join(', ')}.` : '', q.defects.length ? `Also check: ${q.defects.join(', ')}.` : ''].filter(Boolean);
  return { label: `May not look like ${who}`, detail: `${parts.join(' ') || 'The face may not match.'} Redraw this panel to try again.` };
}
